var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-wrapper"},[_c('vue-loading',{attrs:{"color":"#d9544e","size":{ width: '200px', height: '200px' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }